import { Navigate, useLocation } from 'react-router-dom'
import { isCashier, getUserData, hasPermission } from 'helpers/Auth'

import { UseProfile } from 'helpers/UserHooks'

const CASHIER_ALLOWED = ['/pos', '/profile', '/sales', '/', '/customers', '/delivery', '/expenses', '/kitchen']

const WAITER_ALLOWED = ['/waiter', '/pos', '/profile', '/kitchen']

const EXPANDED_PERMISSION_BYPASS = [
 'access_admin_routes',
 'view_reports',
 'manage_inventory',
 'manage_purchases',
 'manage_suppliers',
 'manage_users',
 'manage_employees',
 'manage_attendance',
 'manage_payroll_adjustments',
 'view_payroll',
 'manage_payroll',
 'approve_payroll',
 'pay_payroll',
 'manage_deliveries',
 'delivery_view_settlements',
 'delivery_settle',
 'manage_kitchen',
 'view_account_balances',
 'manage_financial_accounts',
]

const hasExpandedPermissionAccess = (): boolean =>
 EXPANDED_PERMISSION_BYPASS.some((permission) => hasPermission(permission))

const isWaiter = (): boolean => {
 const user = getUserData()
 if (!user) return false
 return Boolean(
 user.roles?.some((r) => r === 'waiter') &&
 !user.roles?.some((r) => r === 'owner' || r === 'Super Admin' || r === 'branch_manager' || r === 'partner')
 )
}

const AuthProtected = ({ children }: { children: React.ReactNode }) => {
 const { userProfile, token } = UseProfile()
 const location = useLocation()

 if (!userProfile && !token) return <Navigate to={{ pathname: '/login' }} />

 const path = location.pathname

 if (isCashier() && !hasExpandedPermissionAccess()) {
 const allowed = CASHIER_ALLOWED.some((p) => path === p || path.startsWith(p + '/'))
 if (!allowed) return <Navigate to={{ pathname: '/pos' }} replace />
 }

 if (isWaiter() && !hasExpandedPermissionAccess()) {
 const allowed = WAITER_ALLOWED.some((p) => path === p || path.startsWith(p + '/'))
 if (!allowed) return <Navigate to={{ pathname: '/waiter' }} replace />
 }

 return <>{children}</>
}

export default AuthProtected
